import React from 'react'

const VerdictResolved = (): React.ReactElement => {
    return (
        <span>
            <svg
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M22.75 12C22.75 6.06294 17.9371 1.25 12 1.25C6.06294 1.25 1.25 6.06294 1.25 12C1.25 17.9371 6.06294 22.75 12 22.75V24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24V22.75C17.9371 22.75 22.75 17.9371 22.75 12Z"
                    fill="#707070"
                />
                <path
                    d="M17.5203 10.839L17.5933 10.9088C17.7436 11.0862 17.7538 11.3511 17.6046 11.541C17.4553 11.731 17.1956 11.7838 16.9876 11.6798L16.9025 11.6253L11.2506 7.18502L9.83524 8.98656L15.4871 13.438C15.7038 13.6088 15.7411 13.9226 15.5706 14.1394C15.3998 14.3563 15.0855 14.3943 14.8685 14.2237L8.82352 9.46342C8.60708 9.2927 8.56977 8.97882 8.74 8.76196L10.7731 6.17406C10.9437 5.95692 11.258 5.91918 11.4752 6.08978L17.5203 10.839Z"
                    fill="#3CB4E5"
                />
                <path
                    d="M7.86062 9.86035L11.6325 5.05931C11.8031 4.84216 12.1174 4.80442 12.3345 4.97502C12.5517 5.14562 12.5894 5.45994 12.4188 5.67709L8.64697 10.4781C8.47638 10.6953 8.16205 10.733 7.94491 10.5624C7.72776 10.3918 7.69003 10.0775 7.86062 9.86035Z"
                    fill="#3CB4E5"
                />
                <path
                    d="M13.9257 14.6434L17.6976 9.8424C17.8682 9.62526 18.1825 9.58752 18.3996 9.75812C18.6168 9.92871 18.6545 10.243 18.4839 10.4602L14.7121 15.2612C14.5415 15.4784 14.2272 15.5161 14.01 15.3455C13.7929 15.1749 13.7551 14.8606 13.9257 14.6434Z"
                    fill="#3CB4E5"
                />
                <path
                    d="M11.6266 11.3094C11.7972 11.0922 12.1114 11.0545 12.3286 11.2251C12.5457 11.3957 12.5834 11.71 12.4128 11.9271L7.60763 18.0435C7.43703 18.2606 7.12278 18.2984 6.90564 18.1278C6.68849 17.9572 6.65077 17.6429 6.82136 17.4258L11.6266 11.3094Z"
                    fill="#3CB4E5"
                />
            </svg>
        </span>
    )
}

export default VerdictResolved
